module.exports = __webpack_public_path__ + "img/20x20SCM-min.8ecf8348.png";